<div class="layout madar--v2">
  <main class="layout__content">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </main>

  <footer class="layout__footer">
    <!-- if there is a footer -->
  </footer>
</div>
